export const breakpointsAliases = ['xs', 'sm', 'md', 'lg', 'xl'];

export const isObject = o => Object.prototype.toString.apply(o) === '[object Object]';

export function variationName(name, value) {
  return value ? `${name}${value.charAt(0).toUpperCase()}${value.slice(1)}` : '';
}

// Generates and registers vue components from polaris-icon svg files
export function getPIconComponents(icons) {
  return icons.reduce((components, icon) => {
    components['P' + icon] = () => import(`polaris-icons/${icon}Icon.svg`);
    return components;
  }, {});
}

export function getResponsiveProps(componentName, componentProp, tokenSubgroup, responsiveProp) {
  if (!responsiveProp) return {};

  let result;

  if (!isObject(responsiveProp)) {
    result = {
      [breakpointsAliases[0]]: `var(--p-${tokenSubgroup}-${responsiveProp})`,
    };
  } else {
    result = Object.fromEntries(
      Object.entries(responsiveProp).map(([breakpointAlias, aliasOrScale]) => [
        breakpointAlias,
        `var(--p-${tokenSubgroup}-${aliasOrScale})`,
      ])
    );
  }

  // Prefix each responsive key with the correct token name
  return Object.fromEntries(
    Object.entries(result).map(([breakpointAlias, value]) => [
      `--pc-${componentName}-${componentProp}-${breakpointAlias}`,
      value,
    ])
  );
}

export function mapResponsiveProp(responsiveProp, callback) {
  if (typeof responsiveProp === 'boolean') {
    return callback(responsiveProp);
  }

  return Object.fromEntries(
    Object.entries(responsiveProp).map(([breakpointsAlias, value]) => [
      breakpointsAlias,
      callback(value),
    ])
  );
}

export function getResponsiveValue(componentName, componentProp, responsiveProp) {
  if (!responsiveProp) return {};

  if (!isObject(responsiveProp)) {
    return {
      [`--pc-${componentName}-${componentProp}-${breakpointsAliases[0]}`]: responsiveProp,
    };
  }

  return Object.fromEntries(
    Object.entries(responsiveProp).map(([breakpointAlias, responsiveValue]) => [
      `--pc-${componentName}-${componentProp}-${breakpointAlias}`,
      responsiveValue,
    ])
  );
}
